/** Shared stagger slide-up motion for nav dropdown preview panels (Blog pattern). */
export const NAV_PREVIEW_EASE_OUT = [0.22, 1, 0.36, 1] as const;

export const navPreviewStagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.09,
      delayChildren: 0.06,
    },
  },
};

export const navPreviewItem = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.48, ease: NAV_PREVIEW_EASE_OUT },
  },
};

export function navPreviewMotionProps(reduceMotion: boolean | null) {
  if (reduceMotion) return {};
  return {
    initial: "hidden" as const,
    animate: "show" as const,
    variants: navPreviewStagger,
  };
}
